import { AubadeComponent } from "js/front/bootstrap";
import { gsap } from "gsap";

class Home extends AubadeComponent {
    constructor(e, b) {
        super(e, b);

        // section slide show

        this.slideW = this.element.querySelector(".slide-wrapper");
        this.slides = this.element.querySelectorAll(".slide");
        this.slidesNumber = this.slides.length;
        this.tl = null;
        this.index = 0;
        this.header = this.bootstrap.components.get(
            document.querySelector("header")
        );
        // section start button
        this.startBtn = this.element.querySelector(".start-btn");

        // section reveals
        this.tlReveal = null;
        this.textWrapperContent = this.element.querySelector(
            ".text-content-wrapper"
        );
        this.slideWrapper = this.element.querySelector(".arc-container");
    }

    async init() {
        this.slideWidth = this.slideW.offsetWidth;
    }

    getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min)) + min;
    }
    attach() {
        this.startBtn.addEventListener("click", this.onStart);
        this.viewport.on("resize", this.onResize);
    }

    detach() {
        this.startBtn.removeEventListener("click", this.onStart);
    }

    onStart = () => {
        this.startBtn.removeEventListener("click", this.onStart);
        dataLayer.push({ event: "CTA Accès Simulateur SdB" });
    };

    open() {
        // reveal
        if (this.viewport.innerWidth > 1280) {
            this.reveals();
        } else {
            this.header.openHeaderHome();
        }
    }

    onResize = () => {
        this.slideWidth = this.slideW.offsetWidth;
    };

    reveals() {
        this.tlReveal?.kill();
        this.tlReveal = gsap.timeline({ delay: 2 });
        const durationReveal = 1;
        this.tlReveal.add(() => {
            this.header.openHeaderHome();
        }, 0);
        this.tlReveal.fromTo(
            this.slideWrapper,
            { x: -100 },
            { x: 0, duration: durationReveal, ease: "power2.out" },
            0
        );
        this.tlReveal.fromTo(
            this.slideWrapper,
            { opacity: 0 },
            { opacity: 1, duration: 1, ease: "linear" },
            "<"
        );
        this.tlReveal.fromTo(
            this.textWrapperContent,
            { x: 100 },
            { x: 0, duration: durationReveal, ease: "power2.out" },
            0
        );
        this.tlReveal.fromTo(
            this.textWrapperContent,
            { opacity: 0 },
            { opacity: 1, duration: 1, ease: "linear" },
            "<"
        );

        this.tlReveal.add(() => {
            //slide show
            setInterval(() => {
                this.moveSlide();
            }, 2400);
        });
    }

    moveSlide() {
        const prevIndex = this.index;

        if (this.index + 1 > this.slides.length - 1) {
            this.index = 0;
        } else {
            this.index++;
        }

        this.tl?.kill();
        this.tl = gsap.timeline();

        this.tl.fromTo(
            this.slides[prevIndex],
            { x: 0 },
            {
                x: -this.slideWidth,
                duration: 1.3,
                ease: "power1.out",
                display: "none"
            },
            0
        );
        this.tl.fromTo(
            this.slides[prevIndex].querySelector("img"),
            { scale: 1 },
            { scale: 1.4, duration: 1.3, ease: "power1.out" },
            0
        );

        this.tl.fromTo(
            this.slides[this.index],
            { x: this.slideWidth, display: "block" },
            { x: 0, duration: 1.3, ease: "power1.out" },
            0
        );
        this.tl.fromTo(
            this.slides[this.index].querySelector("img"),
            { scale: 1.4 },
            { scale: 1, duration: 1.3, ease: "power1.out" },
            0
        );

        this.tl.set(this.slides[prevIndex], { x: this.slideWidth }, 1.3);
    }

    close() {}
}

export { Home };
